import React, {useState} from 'react';
import './styles.css';
import DonutChart from './DonutChart';
import Select from "react-select";

const JobTrendCard = () => {
    const [status, setStatus] = useState('');

    const jobStatus = [
        { value: "Weekly", label: "Weekly" },
        { value: "Annually", label: "Annually" },
      ];
    function customTheme(theme) {
        return {
            ...theme,
            colors: {
                ...theme.colors,
                primary25: "#F2F2F2",
                primary: "#72727233",
            },
        };
    }

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            borderBottom: "none",
            color:"black",
            backgroundColor:"white",
            "&:hover": {
                backgroundColor: "#F0F8F9"
              }
        }),
        control: () => ({
            display: "flex",
            border: "1.3px solid #3c8c9e",
            backgroundColor: "none",
            borderRadius: "3px",
            padding: "4px 0px",
            minHeight: '20px',
            height: '20px',
            width:'170px'
        }),
        input: (provided) => ({
            ...provided,
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: "12px",
            color: "#000000",
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: "none",
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "rgba(0, 0, 0, 0.25)",
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            color: "#0D5C75",
        }),
        valueContainer: (provided) => ({
            ...provided,
        }),
    };
    return (
      <div class="donut-chart" style={{ marginRight:'30px'}}>
        <div style ={{display:'flex', alignItems:'center', justifyContent:'space-around'}}>
        <div style ={{fontSize:'12px', fontWeight:600, marginTop:'10px', marginRight:'50px'}}>Job Status Summary</div>
        <div style= {{paddingTop:'12px'}}>
                    <Select
                        placeholder="Filter Duration"
                        options={jobStatus}
                        theme={customTheme}
                        styles={customStyles}
                        isSearchable={false}
                        value={status}
                        name="status"
                        onChange={(val) =>
                            setStatus(val)
                        }
                    />
        </div>
        </div>
      <div style ={{display:'flex', alignItems:'center'}}>
      <DonutChart isStatusChart={true}/>
      <div style ={{display:'flex', alignItems:'center', flexDirection:'column', marginLeft:'65px'}}>
       <div style ={{display:'flex', alignItems:'center', justifyContent:'space-between', width:'150px', marginLeft:'-16px'}}>
      <span className="dot"></span>
       <div style ={{marginRight:'-1px' }}>Open --------</div> 
       <div style ={{marginLeft:'-2px'}}>08</div>
       </div>
       <div style ={{display:'flex', alignItems:'center', margin:'7px 0px 10px -16px', justifyContent:'space-between', width:'150px'}}>
      <span className="dot" style={{ background: '#3C8C9E' }}></span>
       <div style ={{marginRight:'-1px' }}>In Progress --</div> 
       <div style ={{marginLeft:'-2px'}}>22</div>
       </div>
       <div style ={{display:'flex', alignItems:'center', justifyContent:'space-between', width:'150px', marginLeft:'-16px'}}>
      <span className="dot" style={{ background: '#FE9400' }}></span>
       <div style ={{marginRight:'-1px' }}>Closed -------</div> 
       <div style ={{marginLeft:'-2px'}}>09</div>
       </div>
       </div>
      </div>
      </div>
      
    )
  
}

export default JobTrendCard;